import Request from './Request';

/**
 * Klasse die (erstmal für das Attributwidget aber auch ggf. allgemeiner) das Absetzen von Requests an den Server Regeln soll.
 * Darunter fällt das offline-Handling, oder das "entpacken" von gewissen grunddaten (von Esri Services z.B.).
 * Außerdem soll mithilfe dieser Klasse die Redundanz von Server URLS verringert werden.

 */
class RequestHandler {
  /**
   * @constructor
   *  @param {object} requestOptions
   * @param {string }  [requestOptions.serverUrl = '']
   * @param {string }  [requestOptions.proxyUrl = '']
   * @param {string }  [requestOptions.defaultMethod = 'Post']
   */
  constructor(params) {
    params = params || {}
    const {
      requestOptions: {
        serverUrl = '',
        proxyUrl = '',
        defaultMethod = 'POST',
      } = {},
    } = params;
  
    this.serverUrl = serverUrl;
    this.proxyUrl = proxyUrl;
    this.defaultMethod = defaultMethod;
  }

  getRequest(requestConfig) {
    const {
      name,
      fullUrl,
      proxyUrl,
      url,
      method,
      getParams = [],
      bodyParameter,
      bodyType,
    } = requestConfig;

  }

  request(){

  }
}

export default RequestHandler;
